
import { Sparkles, Loader2 } from "lucide-react";
import { memo } from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  text?: string;
  variant?: "default" | "gradient" | "minimal";
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = memo(({ 
  size = "md", 
  text,
  variant = "default" 
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16"
  };

  const containerSizeClasses = {
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
    xl: "p-8"
  };

  if (variant === "minimal") {
    return (
      <div className="flex items-center justify-center">
        <Loader2 className={`${sizeClasses[size]} animate-spin text-purple-600 dark:text-purple-400`} />
      </div>
    );
  }

  if (variant === "gradient") {
    return (
      <div className={`flex flex-col items-center justify-center space-y-3 ${containerSizeClasses[size]}`}>
        <div className="relative">
          <div className={`${sizeClasses[size]} rounded-full bg-gradient-to-r from-purple-600 via-blue-500 to-pink-500 animate-spin`}>
            <div className="absolute inset-1 bg-background rounded-full"></div>
          </div>
          <Sparkles className="absolute inset-0 m-auto w-3 h-3 text-purple-600 dark:text-purple-400 animate-pulse" />
        </div>
        {text && (
          <p className="text-sm font-medium bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
            {text}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${containerSizeClasses[size]}`}>
      <div className="relative">
        <Loader2 className={`${sizeClasses[size]} animate-spin text-purple-600 dark:text-purple-400`} />
      </div>
      {text && (
        <p className="text-sm font-semibold text-center animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
});

LoadingSpinner.displayName = "LoadingSpinner";

export default LoadingSpinner;
